export const DTF_EXPORT_PROGRESS = "riverr:dtf-export-progress";
export const DTF_EXPORT_KEY = "riverr.dtf.export";
export const DTF_FINISH_FOLDER = "riverr:dtf-finish-folder";

export function emitDtfExport(detail) {
  if (typeof window === "undefined") return;
  const row = { ...(detail || {}), at: Date.now() };
  try {
    sessionStorage.setItem(DTF_EXPORT_KEY, JSON.stringify(row));
  } catch (_err) {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(DTF_EXPORT_PROGRESS, { detail: row }));
}

export function clearDtfExport() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(DTF_EXPORT_KEY);
  } catch (_err) {
    /* ignore */
  }
}

/**
 * A reload drops the in-page printer-folder write. The job and art stay on
 * the server, so a printer send with a job id is continued. A download, or a
 * send we cannot match back to a job, still stops.
 */
export function exportCardAfterReload(row, navType, now = Date.now()) {
  if (!row || !row.phase) return null;
  if (navType !== "reload") return null;
  if (row.phase === "busy" && row.destination === "printer" && row.jobId) {
    return {
      phase: "busy",
      destination: "printer",
      jobId: row.jobId,
      title: "Sending to printer",
      copy: "Finishing the file from the server. You can keep working.",
      pct: 8,
      resume: true,
    };
  }
  if (row.phase === "busy") {
    const printer = row.destination === "printer";
    return {
      phase: "error",
      destination: row.destination,
      title: printer ? "Send stopped" : "Download stopped",
      copy: printer
        ? "The page was refreshed before the file finished. The job is in Sent to printer. Open it and send again if the printer folder is missing the file."
        : "The page was refreshed before the download finished. Open the job and download it again.",
    };
  }
  if (row.phase === "ok" && now - (Number(row.at) || 0) < 10000) return row;
  return { clear: true };
}

export function takeDtfExportAfterLoad() {
  if (typeof window === "undefined") return null;
  let row = null;
  try {
    row = JSON.parse(sessionStorage.getItem(DTF_EXPORT_KEY) || "null");
  } catch (_err) {
    row = null;
  }
  const nav =
    typeof performance !== "undefined"
      ? performance.getEntriesByType("navigation")[0]
      : null;
  const card = exportCardAfterReload(row, nav?.type);
  if (card?.clear) {
    clearDtfExport();
    return null;
  }
  return card;
}
